import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Tree, Input, Icon } from '@h3/antd-vue';
import { listApi } from '../../../../../../api';
import { workflowCenterApi } from '../../../../../../api';
import common from '../../../../../../common';
const Application = listApi;
let WorkflowTree = class WorkflowTree extends Vue {
    constructor() {
        super(...arguments);
        this.workflowTplsTree = [];
        this.parentKey = '';
        this.isShow = false; // 用于重新挂载
        this.lang = 'zh';
        this.isChinese = true;
        this.treeValue = null;
        this.searchResulte = []; // 搜索结果
        this.currentSearchValue = ''; // 当前搜索条件
        this.showName = ''; //选中项的显示名称
        this.historySearchList = []; // 历史记录列表
        this.isShowAll = false;
    }
    scrollCloseTree() {
        if (this.isShow) {
            setTimeout(() => {
                this.isShow = false;
            }, 1000);
        }
    }
    // 返回搜索字段之前的文字
    preHighlightText(value, currentSeachValue) {
        let index = value.indexOf(currentSeachValue);
        if (index < 0) {
            return '';
        }
        return value.substring(0, index);
    }
    // 返回搜索字段之后的文字
    nextHighlightText(value, currentSeachValue) {
        let index = value.indexOf(currentSeachValue);
        if (index < 0) {
            return '';
        }
        return value.substring(index + currentSeachValue.length);
    }
    // 设置高亮文字
    setHighlightText(value) {
        if (!this.currentSearchValue) { // 没有搜索返回原值
            return value;
        }
        let first = this.preHighlightText(value, this.currentSearchValue);
        let last = this.nextHighlightText(value, this.currentSearchValue);
        if (this.currentSearchValue === value) {
            return `<font>${this.currentSearchValue}</font>`;
        }
        if (!first && !last) {
            return value;
        }
        return `${first}<font>${this.currentSearchValue}</font>${last}`;
    }
    showOption() {
        this.isShow = !this.isShow;
        this.$nextTick(() => {
            this.isShow && this.$refs.search_input.focus();
        });
    }
    onSearch(value) {
        this.currentSearchValue = value;
        this.searchWorkflow();
    }
    searchWorkflow() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (Vue.prototype.$httpRequestList.length > 0) { //强行中断时才向下执行
                Vue.prototype.$httpRequestList.forEach((item) => {
                    item('interrupt'); //给个标志，中断请求
                });
            }
            if (this.currentSearchValue === '') { //未输入搜索条件
                this.searchResulte = [];
                return;
            }
            try {
                yield workflowCenterApi.searchMyWorkflowList({
                    workflowName: this.currentSearchValue,
                    language: this.$i18n.locale,
                    isMobile: false
                }).then((res) => {
                    if (res.errcode !== 0) {
                        this.searchResulte = [];
                        return;
                    }
                    if (res.data && Array.isArray(res.data.appList)) {
                        this.searchResulte = res.data.appList;
                    }
                    else {
                        this.searchResulte = [];
                    }
                });
            }
            catch (e) {
                console.log(e);
            }
        });
    }
    // 保存历史最近10个查询记录
    saveHistorySearch() {
        let value = this.currentSearchValue;
        if (value === undefined || value === '') {
            return;
        }
        let index = this.historySearchList.indexOf(value);
        if (index !== -1) {
            this.historySearchList.splice(index, 1);
        }
        else {
            if (this.historySearchList.length >= 10) { // 历史查询记录大于10个，删除一个老数据
                this.historySearchList.pop();
            }
        }
        this.historySearchList.unshift(value);
        localStorage.setItem('processTemplate', JSON.stringify(this.historySearchList));
    }
    // 删除历史记录
    delHistoryItem(item, obj) {
        let index = this.historySearchList.indexOf(item);
        if (index !== -1) {
            this.historySearchList.splice(index, 1);
            localStorage.setItem('processTemplate', JSON.stringify(this.historySearchList));
        }
    }
    delValue() {
        this.$emit('input', '');
        this.$emit('select', {});
        this.isShow = false;
        this.showName = '';
    }
    checkedItem(item) {
        const _workflowCode = 'workflow-' + item.code;
        const name = item.name || item.label;
        const name_i18n = item.name_i18n || {
            en: name
        };
        this.saveHistorySearch();
        this.valueChange(_workflowCode, name, name_i18n);
        this.showName = name;
        this.isShow = false;
    }
    valueChange(_workflowCode, name, name_i18n) {
        if (!_workflowCode)
            return;
        if (this.multiple) {
            const _workflowValue = [...this.treeValue, Object.assign({}, _workflowCode, { name })];
            this.$emit('input', _workflowValue);
        }
        else {
            this.$emit('input', _workflowCode);
        }
        this.$emit('select', { name, name_i18n });
    }
    mounted() {
        this.lang = this.$i18n.locale;
        this.isChinese = !(this.$i18n.locale && this.$i18n.locale === "en");
        this.treeValue = this.value ? this.value : null;
        this.getAppList();
    }
    created() {
        // 加载历史记录
        const historySearchList = localStorage.getItem('processTemplate');
        if (historySearchList) {
            this.historySearchList = JSON.parse(historySearchList);
        }
        else {
            this.historySearchList = [];
        }
        document.addEventListener("click", () => {
            this.isShow = false;
        });
    }
    /**
     * 获取所有应用
    */
    getAppList() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const param = {
                isMobile: false,
            };
            let res = {};
            // 从流程委托过来的增加参数
            if (this.userId) {
                param.userId = this.userId;
                param.trustType = this.trustType;
                res = yield Application.listForTrust(param);
            }
            else {
                param.isPortal = true;
                res = yield Application.list(param);
            }
            if (res.errcode === 0) {
                // 一级树
                const levelOneTree = this.SWTreeGenerator(res.data, 1, 'App');
                this.workflowTplsTree = levelOneTree;
            }
        });
    }
    /**
     * 异步加载数据
    */
    loadTreeData(node) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const _type = node.$vnode.data.props.type;
            const _val = node.$vnode.data.props.value;
            this.parentKey = node.$vnode.data.key;
            switch (_type) {
                case 'App': // 是应用，获取目录
                    this.handleGetAppMenu(_val);
                    break;
                case 'Folder':
                    this.handleGetWorkflowList(_val);
                    break;
                case 'BizModel':
                    this.handleGetWorkflowList(_val);
                    break;
                default:
                    break;
            }
        });
    }
    /**
     * 获取目录
    */
    handleGetAppMenu(code) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // 从流程委托过来的增加参数
            const param = {
                appCode: code,
                isPortal: true
            };
            if (this.userId) {
                param.trustType = this.trustType;
            }
            const appMenuRes = yield Application.getAppItem(param);
            if (appMenuRes.errcode === 0) {
                const _resData = appMenuRes.data;
                if (!_resData || _resData.length === 0)
                    return;
                // 生成树
                const levelTwoTree = this.SWTreeGenerator(_resData, 2, 'Folder', this.parentKey);
                const _p = { key: this.parentKey, tree: levelTwoTree };
                this.setTreeDataAsync(_p);
            }
        });
    }
    clearValue(value) {
        if (!value || (Array.isArray(value) && value.length === 0)) {
            this.$emit('input', '');
        }
    }
    /**
     * 获取流程列表
    */
    handleGetWorkflowList(code) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const params = {
                schemaCode: code,
            };
            // 从流程委托过来的增加参数
            let _worfklowRes = {};
            if (this.userId) {
                params.userId = this.userId;
                params.trustType = this.trustType;
                _worfklowRes = yield Application.getWorkflowListTrust(params);
            }
            else {
                params.isPortal = true;
                _worfklowRes = yield Application.getWorkflowList(params);
            }
            // 获取流程列表 最底层树
            const level = this.parentKey.split('-').length + 1;
            if (_worfklowRes.errcode === 0) {
                const workflowData = _worfklowRes.data;
                if (!workflowData && workflowData.length === 0)
                    return;
                // 流程树
                const workflowList = workflowData.filter((item) => item.published);
                const workflowTree = this.SWTreeGenerator(workflowList, level, 'workflow', this.parentKey);
                const _p = { key: this.parentKey, tree: workflowTree };
                this.setTreeDataAsync(_p);
            }
        });
    }
    /**
      * @description 将异步加载的数据填入树中
      * @param key 类型为 1、1-1、1-1-1、1-1-1-1，根据key来决定赋值操作
    */
    setTreeDataAsync(params) {
        const { key, tree } = params;
        if (!key)
            return;
        const indexs = key.split('-'); // ['1','2','3']
        const temTree = this.workflowTplsTree.slice();
        indexs.forEach((index, i, arr) => {
            indexs[i] = parseInt(index, 10) - 1;
        });
        let arrLen = indexs.length;
        let tmpObj = temTree[indexs[0]];
        for (let i = 1; i < arrLen; i++) {
            if (tmpObj && tmpObj.hasOwnProperty("children")) {
                tmpObj = tmpObj.children[indexs[i]];
            }
        }
        tmpObj.children = tree;
        this.workflowTplsTree = temTree;
    }
    /**
     * 选中树中的节点
    */
    onSelect(v, node) {
        const props = node.selectedNodes[0].data.props || {};
        const _workflowCode = props.value;
        const name = props.name || props.label;
        const name_i18n = props.label_i18n || {
            en: name
        };
        if (!_workflowCode)
            return;
        if (this.multiple) {
            const _workflowValue = [...this.treeValue, Object.assign({}, v, { name })];
            this.$emit('input', _workflowValue);
        }
        else {
            this.$emit('input', _workflowCode);
        }
        this.$emit('select', { name, name_i18n });
        this.showName = name;
        this.isShow = false;
    }
    /**
  * @description 生成自模板树形结构
  * @param data 源数据
  * @param level 当前是几级树
  * @param type 当前树的类型 只有type为'workflow'才可以被选
  * @param parentKey 父级树的key，用于生成当前树的key，第一级时不传
  */
    SWTreeGenerator(data, level, type, parentKey) {
        if (!data || data.length === 0)
            return;
        const tree = [];
        data.forEach((item, index) => {
            const _key = parentKey ? `${parentKey}-${(index + 1).toString()}` : `${(index + 1).toString()}`;
            const _type = type === '' ? item.type : type;
            const _code = type === 'workflow' ? `workflow-${item.workflowCode}` : item.code;
            const _label = type === 'workflow' ? item.workflowName : item.name;
            const _isDisabled = type !== 'workflow';
            const _isLeaf = !(_type === 'Folder' || _type === 'App');
            const _schemaCode = item.schemaCode ? item.schemaCode : '';
            let _icon = '';
            const zhKey = type === 'workflow' ? 'workflowName' : 'name';
            item = common.utils.compatible(item, zhKey);
            if (level === 1) {
                _icon = 'h-icon-all-folder-o';
            }
            else {
                _icon = item.icon ? item.icon : 'h-icon-all-folder-o';
            }
            tree.push({
                type: _type,
                key: _key,
                level,
                label: _label,
                label_i18n: item.name_i18n,
                value: _code,
                icon: _icon,
                schemaCode: _schemaCode,
                disabled: _isDisabled,
                isLeaf: _isLeaf,
                name: _label,
                scopedSlots: {
                    title: 'title',
                },
                children: level === 1 ? [] : this.SWTreeGenerator(item.children, level++, item.type, _key)
            });
        });
        return tree;
    }
    onValueChange(v) {
        if (v === '') {
            this.isShow = false;
            this.showName = '';
            // setTimeout(() => {
            //   this.isShow = true;
            // }, 30);
        }
        this.treeValue = v;
    }
    onLanguageChange(v) {
        this.lang = v;
        this.isChinese = v === 'zh';
        // 中英切换跟数据没有影响，重新请求会只剩下基础树，已选流程会只显示code，不显示名称
        // this.workflowTplsTree = [];
        // this.getAppList();
    }
};
tslib_1.__decorate([
    Prop()
], WorkflowTree.prototype, "value", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], WorkflowTree.prototype, "multiple", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], WorkflowTree.prototype, "labelInValue", void 0);
tslib_1.__decorate([
    Prop({ default: '' })
], WorkflowTree.prototype, "userId", void 0);
tslib_1.__decorate([
    Prop()
], WorkflowTree.prototype, "trustType", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], WorkflowTree.prototype, "hasTabs", void 0);
tslib_1.__decorate([
    Prop({ default: 0 })
], WorkflowTree.prototype, "scrollTop", void 0);
tslib_1.__decorate([
    Watch("scrollTop")
], WorkflowTree.prototype, "scrollCloseTree", null);
tslib_1.__decorate([
    Watch('value')
], WorkflowTree.prototype, "onValueChange", null);
tslib_1.__decorate([
    Watch('$i18n.locale')
], WorkflowTree.prototype, "onLanguageChange", null);
WorkflowTree = tslib_1.__decorate([
    Component({
        name: 'workflow-tree',
        components: {
            ATree: Tree,
            AInput: Input,
            AIcon: Icon
        }
    })
], WorkflowTree);
export default WorkflowTree;
